import assetManifest from './AssetManifest';

class Loader {
  constructor() {
    this.queue = new createjs.LoadQueue();
    this.queue.setMaxConnections(10);
    this.queue.installPlugin(createjs.Sound);
    this.queue.on('complete', this.handleAllFilesLoaded.bind(this));
    this.queue.on('error', Loader.errorLoading);
    this.callbacks = [];
    this.loadedAllItems = false;
  }

  static errorLoading(event) {
    console.error(`Error loading file: `);
    console.error(event);
  }

  addItems(owner, items) {
    this.callbacks.push(owner.loaded.bind(owner));
    items.forEach(item => {
      this.addItem(owner, item, false);
    });
  }

  addItem(owner, item, solo = true) {
    if (solo) {
      this.callbacks.push(owner.loaded.bind(owner));
    }
    const name = item;
    this.loadedItems = false;
    const fname = assetManifest.getFName(name);
    assetManifest.addItem(name, fname);
  }

  getItem(name) {
    return this.queue.getResult(name);
  }

  loadItems() {
    console.debug('Loading items', assetManifest.manifest);
    this.queue.loadManifest(assetManifest.manifest);
  }

  handleAllFilesLoaded() {
    this.callbacks.filter(callback => {
      callback();
      return false;
    });
    this.loadedAllItems = true;
    const el = document.querySelector('.loadingclass');
    el.classList.add('hide');
  }
}

const loader = new Loader();

export { loader as default };
